import { getRoleLabel } from './user';

import { getProject } from '../services/store-service';

import moment from 'moment';

import botImage from '../images/nifty-orbit.png';

export const NO_FLAG_ACTIVITIES = ['task.complete', 'subtask.complete'];

export const COMMENT_NOTIFICATION_TYPES = ['tag', 'comment'];

export const VALID_ACTIVITIES = [
    'system.alert',

    'team.join',
    'team.leave',

    'project.leave',
    'project.invite',
    'project.archive',

    'document.invite',
    'document.tag',

    'file.tag',

    'task.assign',
    'task.tag',
    'task.complete',
    'task.move',
    'task.archive',
    'task.alert',

    'subtask.assign',
    'subtask.complete',

    'thread.tag'
];

export const VALID_USER_ACTIVITIES = [
    'project.join',
    'project.leave',
    'project.archive',

    'document.invite',
    'document.comment',
    'document.tag',

    'file.comment',
    'file.tag',

    'task.assign',
    'task.comment',
    'task.tag',
    'task.complete',
    'task.move',
    'task.archive',

    'subtask.assign',
    'subtask.complete',

    'message.tag',
    'message.upload',

    'thread.tag'
];

export const VALID_ACTIVITIES_FOR_PANEL = [
    'system.alert',

    'team.join',
    'team.leave',

    'project.leave',
    'project.invite',
    'project.archive',

    'message.tag',

    'document.invite',
    'document.comment',
    'document.tag',

    'file.tag',
    'file.comment',

    'task.assign',
    'task.tag',
    'task.comment',
    'task.complete',
    'task.move',
    'task.archive',
    'task.alert',

    'subtask.assign',
    'subtask.complete',

    'message.tag',

    'thread.tag',
    'thread.comment',
    'thread.upload'
];

export const FILTERS = {
    'mentioned': [
        'message.tag',
        'document.tag',
        'file.tag',
        'task.tag',
        'message.tag',
        'thread.tag'
    ],
    'assigned': [
        'task.assign',
        'subtask.assign'
    ],
    'shared': [
        'document.invite'
    ]
};

export const FAVICON_CHANGE_ACTIVITIES = ['message.create'];

const PROJECT_MAIN_NOTIFICATION_TYPES = ['message', 'thread', 'task', 'subtask', 'document', 'file'];

export const notificationIsUnread = notification => notification && !notification.is_read;

const isNotificationValid = notification => notification && VALID_ACTIVITIES_FOR_PANEL.includes(`${notification.type}.${notification.action}`);

export const getActivities = notifications => notifications.filter(isNotificationValid);

export const generateFilters = pairs =>
    pairs.reduce((filter, pair) => {
        const [type, action] = pair.split('.');
        if (!(type in filter)) {
            filter[type] = [];
        }

        filter[type].push(action);

        return filter;
    }, {});

export const getUnreadActivities = notifications => getActivities(notifications).filter(notificationIsUnread);

const getSystemMessage = text => {
    return text.replace(/^(Overdue\sTask:\s)(.+)$/, '$1**$2**');
}

const getSystemUrl = notification => {
    if (notification.url) {
        return notification.url;
    }

    if (notification.association && notification.association.type) {
        switch (notification.association.type) {
            case 'Task':
                return [notification.project.id, 'task', notification.association.id].join('/');

            default:
                // es lint
        }
    }

    return null;
}
const getCleanString = input => {
    if (!input) {
        return 'removed';
    }

    return input.trim();
}

export const getNotificationProps = (notification, currentUserId, locale, t) => {
    const user = notification.user_in_question;
    const triggeredBy = notification.triggered_by;
    const project = notification.project ? ((notification.project.id && getProject(notification.project.id)) || notification.project) : null;
    const { team, association, receiver } = notification;
    const url = [];
    const isSelf = currentUserId && triggeredBy && currentUserId === triggeredBy.id;
    const meta = [];
    const activityProps = {};
    let text;
    let activityKey;
    let firstPersonToMe = false;
    let avatar = 'triggered_by';
    let includeTeam = true;

    switch (`${notification.type}.${notification.action}`) {
        case 'system.alert':
            avatar = 'nifty';
            text = getSystemMessage(notification.message);

            const systemUrl = getSystemUrl(notification);
            if (systemUrl) {
                url.push('', systemUrl);
            }
            break;

        case 'team.join':
            avatar = 'team';
            activityKey = 'teamJoin';
            activityProps.user = (user || triggeredBy).name;
            activityProps.team = team.name;

            if ((user || triggeredBy).role) {
                activityKey = 'teamJoinWithRole';
                activityProps.role = getRoleLabel((user || triggeredBy).role);
            }

            includeTeam = false;
            break;

        case 'team.leave':
            avatar = 'team';
            activityKey = 'teamLeave';
            activityProps.user = (user || triggeredBy).name;
            activityProps.team = team.name;

            includeTeam = false;
            break;

        case 'team.invite':
            avatar = 'team';
            activityKey = 'teamInvite';
            activityProps.user = (user || triggeredBy).name;
            activityProps.team = team.name;
            includeTeam = false;
            break;

        case 'project.join':
            if (!project) {
                return null;
            }

            avatar = 'project';
            url.push('', project.id);
            activityKey = 'projectJoin';
            activityProps.user = user.name;
            activityProps.project = project?.name;
            break;

        case 'project.invite':
            if (!project) {
                return null;
            }

            avatar = 'project';
            url.push('', project.id);
            activityKey = 'projectInvite';
            activityProps.user = triggeredBy.name;
            activityProps.project = project?.name;
            break;

        case 'project.leave':
            if (!project) {
                return null;
            }

            avatar = 'project';

            activityKey = 'projectLeave';
            activityProps.user = user.name;
            activityProps.project = project?.name;
            break;

        case 'project.archive':
            avatar = 'project';
            url.push('', 'settings', 'project', project.id);

            activityKey = 'projectArchive';
            activityProps.user = triggeredBy.name;
            activityProps.project = project?.name;
            break;

        case 'document.invite':
            url.push('', project.id, 'documents', 'root', association.id);

            activityKey = 'docInvite';
            activityProps.user = triggeredBy.name;
            activityProps.doc = association.name;
            activityProps.project = project?.name;

            if (!isSelf && receiver) {
                activityProps.receiver = receiver.name
            } else {
                firstPersonToMe = true;
            }
            break;

        case 'document.tag':
            url.push('', project.id, 'documents', 'root', association.id, association.entity_key);

            activityKey = 'docTag';
            activityProps.user = triggeredBy?.name;
            activityProps.doc = association?.name;
            activityProps.project = project?.name;

            if (!isSelf && receiver) {
                activityProps.receiver = receiver.name
            } else {
                firstPersonToMe = true;
            }
            break;

        case 'document.comment':
            url.push('', project.id, 'documents', 'root', association.id, association.entity_key);

            activityKey = 'docComment';
            activityProps.user = triggeredBy?.name;
            activityProps.doc = association?.name;
            activityProps.project = project?.name;
            break;

        case 'file.tag':
            if (project) {
                url.push('', project.id, 'files', 'root', 'file', association.id, 'comments');
                activityKey = 'projectFileTag';
                activityProps.project = project?.name;
            } else {
                url.push('', 'files', 'root', 'file', association.id, 'comments');
                activityKey = 'fileTag';
                activityProps.project = project?.name;
            }

            activityProps.user = triggeredBy.name;
            activityProps.file = association.name;

            if (!isSelf && receiver) {
                activityProps.receiver = receiver.name
            } else {
                firstPersonToMe = true;
            }
            break;

        case 'file.comment':
            if (project) {
                url.push('', project.id, 'files', 'root', 'file', association.id, 'comments');
                activityKey = 'projectFileComment';
                activityProps.project = project?.name;
            } else {
                url.push('', 'files', 'root', 'file', association.id, 'comments');
                activityKey = 'fileComment';
            }

            activityProps.user = triggeredBy.name;
            activityProps.file = association.name;
            break;

        case 'task.assign':
            url.push('', project.id, 'task', association.id);

            activityKey = 'taskAssign';
            activityProps.user = triggeredBy.name;
            activityProps.task = association.name;
            activityProps.project = project?.name;

            if (!isSelf && receiver) {
                activityProps.receiver = receiver.name
            } else {
                firstPersonToMe = true;
            }
            break;

        case 'task.tag':
            if (association.task_id) {
                url.push('', project.id, 'task', association.task_id, association.id);
                activityKey = 'subtaskTag';
            } else {
                url.push('', project.id, 'task', association.id, 'comments');
                activityKey = 'taskTag';
            }

            activityProps.user = triggeredBy.name;
            activityProps.task = association.name;
            activityProps.project = project?.name;

            if (!isSelf && receiver) {
                activityProps.receiver = receiver.name
            } else {
                firstPersonToMe = true;
            }
            break;

        case 'task.comment':
            if (association.task_id) {
                url.push('', project.id, 'task', association.task_id, association.id);
                activityKey = 'subtaskComment';
            } else {
                url.push('', project.id, 'task', association.id, 'comments');
                activityKey = 'taskComment';
            }

            activityProps.user = triggeredBy.name;
            activityProps.task = association.name;
            activityProps.project = project?.name;
            break;

        case 'task.complete':
            url.push('', project.id, 'task', association.id);

            activityKey = 'taskComplete';
            activityProps.user = triggeredBy.name;
            activityProps.task = association.name;
            activityProps.project = project?.name;
            break;

        case 'task.move':
            url.push('', project.id, 'task', association.id);

            activityKey = 'taskMove';
            activityProps.user = triggeredBy.name;
            activityProps.task = association.name;
            activityProps.project = project?.name;
            break;

        case 'task.archive':
            avatar = 'project';

            activityKey = 'taskArchive';
            activityProps.user = triggeredBy.name;
            activityProps.task = association.name;
            activityProps.project = project?.name;
            break;

        case 'task.alert':
            avatar = 'project';
            url.push('', project.id, 'task', association.id);

            activityKey = 'taskAlert';
            activityProps.task = association.name;
            activityProps.date = moment(association.due_date).format(locale?.dateTimeFormats?.fullDateTime);
            activityProps.project = project?.name;
            break;

        case 'subtask.assign':
            url.push('', project.id, 'task', association.task_id, 'subtasks');

            activityKey = 'subtaskAssign';
            activityProps.user = triggeredBy.name;
            activityProps.subtask = association.name;
            activityProps.project = project?.name;

            if (!isSelf && receiver) {
                activityProps.receiver = receiver.name
            } else {
                firstPersonToMe = true;
            }
            break;

        case 'subtask.complete':
            url.push('', project.id, 'task', association.task_id, 'subtasks');

            activityKey = 'subtaskComplete';
            activityProps.user = triggeredBy.name;
            activityProps.subtask = association.name;
            activityProps.project = project?.name;
            break;

        case 'message.tag':
            if (project) {
                url.push('', project.id, 'discussion', association.message_id);

                activityKey = 'projectMessageTag';
                activityProps.project = project?.name || association.name;

                if (!isSelf && receiver) {
                    activityProps.receiver = receiver.name
                } else {
                    firstPersonToMe = true;
                }
            } else {
                url.push(`#chat=${association.id}`);

                activityKey = 'directMessageTag';
                includeTeam = false;
            }

            activityProps.message = notification.detailed_message;
            activityProps.user = triggeredBy.name;
            break;

        case 'message.create':
            if (project) {
                url.push('', project.id, 'discussion', association.message_id);

                activityKey = 'projectMessageCreate';
                activityProps.project = project?.name || association.name;
            } else {
                url.push(`#chat=${association.id}`);

                activityKey = 'directMessageCreate';
                includeTeam = false;
            }

            activityProps.message = notification.detailed_message;
            activityProps.user = triggeredBy.name;
            break;

        case 'message.upload':
            if (project) {
                url.push('', project.id, 'discussion', association.message_id);

                activityKey = 'projectMessageUpload';
                activityProps.project = project?.name || association.name;
            } else {
                url.push(`#chat=${association.id}`);

                activityKey = 'directMessageUpload';
                includeTeam = false;
            }

            activityProps.message = notification.detailed_message;
            activityProps.user = triggeredBy.name;
            break;

        case 'message.doc':
            if (project) {
                url.push('', project.id, 'discussion', association.message_id);

                activityKey = 'projectMessageDoc';
                activityProps.project = project?.name || association.name;
            } else {
                url.push(`#chat=${association.id}`);

                activityKey = 'directMessageDoc';
                includeTeam = false;
            }

            activityProps.message = notification.detailed_message;
            activityProps.user = triggeredBy.name;
            break;

        case 'thread.tag':
            url.push('', project.id, 'discussion', 'thread', association.id);

            activityKey = 'threadTag';
            activityProps.user = triggeredBy.name;
            activityProps.message = notification.detailed_message;
            activityProps.project = project?.name;

            if (!isSelf && receiver) {
                activityProps.receiver = receiver.name
            } else {
                firstPersonToMe = true;
            }
            includeTeam = false;
            break;

        case 'thread.comment':
            url.push('', project.id, 'discussion', 'thread', association.id);

            activityKey = 'threadComment';
            activityProps.user = triggeredBy.name;
            activityProps.message = notification.detailed_message;
            activityProps.project = project?.name;
            includeTeam = false;
            break;

        case 'thread.upload':
            url.push('', project.id, 'discussion', 'thread', association.id);

            activityKey = 'threadUpload';
            activityProps.user = triggeredBy.name;
            activityProps.message = notification.detailed_message;
            activityProps.project = project?.name;
            includeTeam = false;
            break;

        default:
            return null;
    }

    meta.push(notification.title);

    if (includeTeam && notification.team) {
        meta.push(notification.team.name);
    }

    Object.keys(activityProps).forEach(key => {
        activityProps[key] = getCleanString(activityProps[key]);
    });

    return {
        text: !activityKey ? text : t(`notifications:activities.${activityKey}.regular`, activityProps),
        cardHead: !activityKey ? '' : t(`notifications:activities.${activityKey}.cardHead`, activityProps),
        cardBody: !activityKey ? '' : t(`notifications:activities.${activityKey}.cardBody`, activityProps),
        firstPersonText: !activityKey ? '' : t(`notifications:activities.${activityKey}.${firstPersonToMe ? 'firstPersonToMe' : 'firstPerson'}`, activityProps),
        url: url.join('/'),
        meta: meta.join(' | '),
        avatar: avatar === 'nifty' ? {
            image: botImage
        } : {
            image: notification[avatar].avatar || notification[avatar].logo,
            color: notification[avatar].color,
            secondaryColor: notification[avatar].secondary_color,
            text: notification[avatar].initials
        }
    }
}

export const getLastUserActivity = (notifications, userId, validActivities = VALID_USER_ACTIVITIES) => notifications
    .sort((a, b) => new Date(b.created_at) - new Date(a.created_at))
    .find(notification => notification && validActivities.includes(`${notification.type}.${notification.action}`) && notification.triggered_by && notification.triggered_by.id === userId);

export const getNotificationsForProjects = (notifications, projectIds) => notifications
    .filter(notification => notificationIsUnread(notification) &&
        notification.project &&
        projectIds.includes(notification.project.id) &&
        !NO_FLAG_ACTIVITIES.includes(`${notification.type}.${notification.action}`) &&
        (
            notification.type === 'project' ||
            PROJECT_MAIN_NOTIFICATION_TYPES.includes(notification.type)
        )
    );

export const getTaskNotifications = (notifications, taskId, all, withoutSubtaskComment) => notifications
    .filter(notification =>
        notificationIsUnread(notification) &&
        notification.association &&
        (all || !NO_FLAG_ACTIVITIES.includes(`${notification.type}.${notification.action}`)) &&
        (
            (
                notification.association.task_id === taskId &&
                (
                    !withoutSubtaskComment ||
                    !COMMENT_NOTIFICATION_TYPES.includes(notification.action)
                )
            ) ||
            notification.association.id === taskId
        )
    );

export const filterNotifications = (notifications, { projectId, associationId, association, type, customKey, customValue, tasksIds, taskId }) => {
    return notifications.filter(notification => {
        if (!notification || notification.is_read) {
            return false;
        }

        if (projectId) {
            return notification.project && notification.project.id === projectId;
        }

        if (associationId) {
            return notification.association_id === associationId;
        }

        if (association) {
            return notification.association === association;
        }

        if (type) {
            return notification.type === type;
        }

        if (customKey && customKey in notification) {
            return notification[customKey] === customValue;
        }

        if (taskId && notification.task) {
            return notification.task.id === taskId;
        }

        if (tasksIds && tasksIds.length) {
            return tasksIds.some(taskId => notification.association && (notification.association.id === taskId || notification.association.task_id === taskId));
        }

        return false;
    });
}
